import { useAutoratingStore } from '../Autorating/Autorating.store';
import { useMemo } from 'react';

export const useAIAssessment = () => {
  // Store values
  const filledWithAI = useAutoratingStore((state) => state?.filledWithAI);
  const tempEditFeedback = useAutoratingStore((state) => state?.tempEditFeedback);
  const responseData = useAutoratingStore((state) => state?.responseData);
  const reset = useAutoratingStore((state) => state?.reset);
  const isLoading = useAutoratingStore((state) => state?.isLoading);

  // Store setters
  const setTempEditFeedback = useAutoratingStore((state) => state?.setTempEditFeedback);
  const setIsLoading = useAutoratingStore((state) => state?.setIsLoading);

  /** Is AI auto-rated assessment FF enabled and assessment has been filled by AI*/
  const isFilledWithAI = useMemo(() => filledWithAI, [filledWithAI]);

  /** For questions of type 1, 2, 3, and 4 that contain an external URL as a response, AI components will not be shown. Instead, only a tooltip will be shown.  */
  const shouldShowTooltipForUnsupportedQuestion = (list) => {
    return list.some((i) => i?.answer?.status === 'UNSUPPORTED');
  };

  const getTitleForUnsupportedUrlAnswer = (list) => list[0]?.answer?.error_msg;

  return {
    filledWithAI,
    setTempEditFeedback,
    tempEditFeedback,
    responseData,
    reset,
    isFilledWithAI,
    isLoading,
    setIsLoading,
    shouldShowTooltipForUnsupportedQuestion,
    getTitleForUnsupportedUrlAnswer,
  };
};
